// HospiceCare.js
import React from 'react';
import ServiceHero from '../components/ServiceHero';
import HospiceComfortSection from '../components/HospiceComfortSection';
import EmpatheticCaregiversSection from '../components/EmpatheticCaregiversSection';
import ThreeStepsSection from '../components/ThreeStepsSection';
import AllServicesShowcase from '../components/AllServicesShowcase';

const HospiceCare = () => {
  const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Home Care Services', link: null },
    { label: 'Hospice Care', link: null }
  ];

  return (
    <div className="min-h-screen bg-white">
      <ServiceHero
        breadcrumbs={breadcrumbs}
        title="Hospice Care That Focuses on Comfort and Connection"
        description="Our hospice care supports patients and families with warmth, understanding, and meaningful care during life's most delicate moments."
      />
      <HospiceComfortSection />
      <EmpatheticCaregiversSection />
      <ThreeStepsSection />
      <AllServicesShowcase />
    </div>
  );
};

export default HospiceCare;
